import * as Yup from "yup";

import { SITE_NAME } from "@shared/constants";

import type CCPAForm from "@packages/types/ccpa-form";

export const CCPA_STATES_WITH_PRIVACY_LAWS = [
  "CA",
  "CO",
  "CT",
  "NE",
  "NJ",
  "TX",
];

export const initialValues: CCPAForm.Values = {
  authorizedAgentFirstName: "",
  authorizedAgentLastName: "",
  authorizedAgentPhoneNumber: "",
  authorizedAgentEmail: "",
  ccpaRequestorType: "Self",
  ccpaRequestTypes: [],
  firstName: "",
  lastName: "",
  streetAddress: "",
  city: "",
  state: "",
  email: "",
  phoneNumber: "",
  siteName: SITE_NAME,
  zipCode: "",
};

export const validationSchema = Yup.object({
  authorizedAgentEmail: Yup.string().when(
    "ccpaRequestorType",
    (ccpaRequestorType, schema) => {
      if (ccpaRequestorType[0] === "Authorized Agent") {
        return schema
          .email("Please enter a valid email address")
          .required("Please enter your authorized agent email address");
      }

      return schema;
    },
  ),
  authorizedAgentFirstName: Yup.string().when(
    "ccpaRequestorType",
    (ccpaRequestorType, schema) => {
      if (ccpaRequestorType[0] === "Authorized Agent") {
        return schema.required("Please enter your authorized agent first name");
      }

      return schema;
    },
  ),
  authorizedAgentLastName: Yup.string().when(
    "ccpaRequestorType",
    (ccpaRequestorType, schema) => {
      if (ccpaRequestorType[0] === "Authorized Agent") {
        return schema.required("Please enter your authorized agent last name");
      }

      return schema;
    },
  ),
  authorizedAgentPhoneNumber: Yup.string().when(
    "ccpaRequestorType",
    (ccpaRequestorType, schema) => {
      if (ccpaRequestorType[0] === "Authorized Agent") {
        return schema.required("Please enter your authorized agent phone number");
      }

      return schema;
    },
  ),
  ccpaRequestorType: Yup.string().required("Please select an option"),
  ccpaRequestTypes: Yup.array()
    .of(Yup.string().required())
    .required()
    .when("state", (state, schema) => {
      if (CCPA_STATES_WITH_PRIVACY_LAWS.includes(state[0])) {
        return schema.min(1, "Please select a request type");
      }

      return schema;
    }),
  firstName: Yup.string().required("Please enter your first name"),
  lastName: Yup.string().required("Please enter your last name"),
  streetAddress: Yup.string()
    .min(3, "Please enter your street address")
    .matches(/[0-9]\s/, "Please enter your street address")
    .matches(/[a-zA-Z]/, "Please enter your street address")
    .required("Please enter your street address"),
  city: Yup.string().required("Please enter your city name"),
  state: Yup.string().required("Please select your state"),
  email: Yup.string().required("Please enter your email address"),
  phoneNumber: Yup.string().required("Please enter your phone number"),
  zipCode: Yup.string()
    .matches(/^[0-9]+$/, "Please enter your 5-digit zip code")
    .min(5, "Please enter your 5-digit zip code")
    .max(5, "Please enter your 5-digit zip code")
    .required("Please enter your 5-digit zip code"),
});
